import './polyfill';
import React from 'react';
import { withPrefix } from 'gatsby';
import onTab from './src/styles/onTab';
import RootWrapper from './src/RootWrapper';
import PageWrapper from './src/PageWrapper';
import configureServices from './src/services';
import analyticsApiClient from './src/services/Analytics';
import context from './src/context';
import { handleEventInOptimizely } from './src/optimizely';
import { makeStore, startAppListening } from './src/store';
import { initAppListeners } from './src/store/listenerMiddleware.ts';
import {
  shouldRedirect,
  getBokaSubPathname,
  getServiceUnavailableUrl,
  addPersistingQueryParamsToPath,
  getSubPathsForBoka,
} from './src/helpers/urlHelper.ts';
import { setNativeAppTheme } from './src/helpers/nativeAppHelper.ts';
import { getPagePath } from './src/helpers/urlHelper.ts';

/* globals CSS_CONFIG, MAINTENANCE_MODE */

const store = makeStore(initAppListeners(startAppListening));

export const wrapRootElement = ({ element }) => (
  <RootWrapper store={store} element={element} />
);

export const wrapPageElement = PageWrapper;

export const onClientEntry = async () => {
  setNativeAppTheme();

  if (
    MAINTENANCE_MODE === 'true' &&
    window.location.href.indexOf('service-unavailable') === -1
  ) {
    const serviceUnavailableUrl = getServiceUnavailableUrl();
    window.location.assign(
      addPersistingQueryParamsToPath(serviceUnavailableUrl, {
        exclude: ['vpc', 'projectd'],
      }),
    );
  }

  const services = await configureServices();
  context.registerServices(services);

  const { search } = store.getState();
  const redirect = shouldRedirect(search.postCode);

  if (redirect) {
    const [operation] = getSubPathsForBoka(window.location.pathname);
    const path = getPagePath(operation);
    window.location.href = addPersistingQueryParamsToPath(withPrefix(path));
  }
};

const routeHasChanged = (location, prevLocation) => {
  if (!prevLocation) {
    return false;
  }

  const currentPath = getBokaSubPathname(location.pathname);
  const prevPath = getBokaSubPathname(prevLocation.pathname);
  return currentPath !== prevPath;
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  const { handleEventInGoogleAnalytic, sendPageview } = analyticsApiClient();
  const { app, search, services, stores } = store.getState();
  const { operation } = app;
  const { serviceId, storeId } = app.selected;
  const { pathname } = location;

  if (pathname.endsWith('/services/')) {
    handleEventInGoogleAnalytic(`begin_${operation}_appointment`, {
      postalCode: search.postCode,
      step: '1',
    });
  }

  if (pathname.endsWith('/timeslots/')) {
    handleEventInGoogleAnalytic(`${serviceId}_${operation}_appointment`, {
      postalCode: search.postCode,
      step: '2',
      options: {
        serviceId,
        services: services.availableServices,
      },
    });
  }

  if (pathname.endsWith('/contact/') && operation && serviceId) {
    handleEventInGoogleAnalytic(
      `select_date_and_time_${serviceId}_${operation}_appointment`,
      {
        postalCode: search.postCode,
        step: '3',
        options: {
          serviceId,
          services: services.availableServices,
          storeId,
          stores: stores.availableStores,
        },
      },
    );
  }
  if (pathname.endsWith('/confirm/')) {
    if (CSS_CONFIG.OPTIMIZELYEVENTS.completeBooking) {
      handleEventInOptimizely('booking_complete_global');
      handleEventInOptimizely(`booking_complete_${CSS_CONFIG.COUNTRY}`);
    }
    handleEventInGoogleAnalytic(
      `complete_${serviceId}_${operation}_appointment`,
      {
        postalCode: search.postCode,
        step: '4',
        options: {
          serviceId,
          services: services.availableServices,
          storeId,
          stores: stores.availableStores,
        },
      },
    );
  }

  if (routeHasChanged(location, prevLocation)) {
    sendPageview();
  }
};

onTab();
